import React, { FC, useContext, useEffect, useState } from 'react'
import DatePickerC from '../../DatePicker'
import { Context } from '../../../context'
import { useTranslation } from 'react-i18next'
import { handleDate } from '../../../utils'
import { IDatePickerSearch } from './SeacrhToolTypes/DatePickerS.type'

const DatePickerSearch: FC<IDatePickerSearch> = ({ Header, isMulti, className ,accessor, probName }) => {

    const [dates, setDates] = useState<any>()

    const { setCustomSearchData, customSearchData, clearField } = useContext(Context)

    const { t } = useTranslation()

    useEffect(() => {
        let searchObjectValues :any= customSearchData;

        if (!isMulti) {
            searchObjectValues[probName || Header] = handleDate(dates)
        } else {
            searchObjectValues[`${probName || Header}From`] = handleDate(dates?.from)
            searchObjectValues[`${probName || Header}To`] = handleDate(dates?.to)
        }

        setCustomSearchData((prev: any) => searchObjectValues)

    }, [dates])

    useEffect(() => {
        setDates(null)
    }, [clearField])

    return (
        <>
            <DatePickerC className={className} Apply={setDates} dates={dates} isSingle={!isMulti} placeholder={t(Header) || ''} />
        </>
    )
}

export default DatePickerSearch